import { render, staticRenderFns } from "./ExclusaoProdutoCombinado.vue?vue&type=template&id=1b1ff66f&scoped=true"
import script from "./ExclusaoProdutoCombinado.vue?vue&type=script&setup=true&lang=js"
export * from "./ExclusaoProdutoCombinado.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1ff66f",
  null
  
)

export default component.exports